import { render, staticRenderFns } from "./SupplyChain.vue?vue&type=template&id=e039bd8e&scoped=true&"
import script from "./SupplyChain.vue?vue&type=script&lang=js&"
export * from "./SupplyChain.vue?vue&type=script&lang=js&"
import style0 from "./SupplyChain.vue?vue&type=style&index=0&id=e039bd8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e039bd8e",
  null
  
)

export default component.exports